export default class AdminLogsHeadersCreate extends React.Component {
  static propTypes = PropTypesExact({
    log: PropTypes.instanceOf(Log).isRequired
  })

  render() {
    return I18n.t("js.admin.logs.headers.create.create")
  }
}
